import request from './request'

export function listAttribute(data) {
  return request.post('/mes/attributes/list', data)
}
export function selectAttribute() {
  return request.get('/mes/attributes/select')
}
export function getAttribute(id) {
  return request.get('/mes/attributes/' + id)
}
export function saveAttribute(data) {
  return request.post('/mes/attributes', data)
}
export function updateAttribute(data) {
  return request.post('/mes/attributes/update', data)
}
export function deleteAttribute(ids) {
  return request.post('/mes/attributes/delete', ids)
}
